import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import T from '../../Locale';
import { toggleModal } from '../../Actions';
import BaseModal from '../../Components/ComponentModal';
import Button from '../../Components/ComponentButton';
import { deleteDocument } from './Actions';
class ComponentDeleteModal extends Component {
    constructor(props) {
        super(props);
        this.state = { isDeleting: false };
        this.delete = this.delete.bind(this);
    }
    delete() {
        const { id, dispatch } = this.props;
        this.setState({ isDeleting: true });
        dispatch(deleteDocument(id))
            .then((success) => {
            if (!success) {
                this.setState({ isDeleting: false });
            }
        }, () => {
            this.setState({ isDeleting: false });
        });
    }
    render() {
        const { isDeleting } = this.state;
        const { dispatch, name } = this.props;
        return (_jsxs(BaseModal, Object.assign({ modalKey: "document_delete", title: T.translate('documents.delete.title'), content: T.translate('documents.delete.content', { document: name }) }, { children: [_jsx("br", {}), _jsx(Button, Object.assign({ onClick: () => this.delete(), isLoading: isDeleting }, { children: T.translate('documents.delete.proceed') })), _jsx(Button, Object.assign({ onClick: () => dispatch(toggleModal()), classes: "button transparent" }, { children: T.translate('documents.delete.cancel') }))] })));
    }
}
ComponentDeleteModal.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    dispatch: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
    id: state.application.modalId,
    name: state.application.modalName
});
export default connect(mapStateToProps)(ComponentDeleteModal);
